import * as React from 'react';
import * as Icons from 'lucide-react';
import { cn } from '@/lib/utils';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import type { Badge } from '@/lib/badges';

const tierStyles = {
  bronze: 'bg-orange-100 text-orange-700 border-orange-300 dark:bg-orange-900/30 dark:text-orange-400 dark:border-orange-700',
  silver: 'bg-slate-100 text-slate-600 border-slate-300 dark:bg-slate-800/50 dark:text-slate-300 dark:border-slate-600',
  gold: 'bg-yellow-100 text-yellow-700 border-yellow-300 dark:bg-yellow-900/30 dark:text-yellow-400 dark:border-yellow-700 shadow-[0_0_10px_rgba(234,179,8,0.3)] animate-pulse-subtle',
};

export function BadgeDisplay({ badges }: { badges: Badge[] }) {
  if (badges.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-2">
      {badges.map((b) => {
        const Icon = (Icons as Record<string, React.ComponentType<{ className?: string }>>)[b.icon] ?? Icons.Award;
        return (
          <Tooltip key={b.id}>
            <TooltipTrigger asChild>
              <span
                data-testid={`badge-${b.id}`}
                className={cn(
                  'inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold border cursor-default',
                  tierStyles[b.tier]
                )}
              >
                <Icon className="h-3.5 w-3.5" />
                {b.label}
              </span>
            </TooltipTrigger>
            <TooltipContent>
              <p>{b.description}</p>
            </TooltipContent>
          </Tooltip>
        );
      })}
    </div>
  );
}
